import { inject } from '@angular/core';
import { AuthService, TelemetryService } from '#services';

export const appInitializer = () => {
  const authService = inject(AuthService);
  const telemetryService = inject(TelemetryService);

  telemetryService.initialize();

  return authService.initialize().then(() => {
    telemetryService.setAuthenticatedUser(authService.getAccountEmail());
  });
};
